/* eslint-disable no-console */
import _ from 'underscore';
import {
  getPosterImageFromVideoUrl,
  updateAssetUrlDimensions,
} from '../../utils/widen-utils';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const imageTemplate = `<div class="object-fit site-image-wrapper">
    <img class="site-image lazy" src="{{ src }}" alt="" />
  </div>`;
const videoTemplate = `<div class="card-image card-video">
    <button
      class="button-reset button-video"
      data-modal-id="video-modal"
      data-video-url="{{ dataVideoUrl }}"
    >
      <div class="object-fit site-image-wrapper">
          <img class="site-image lazy" src="{{ src }}" alt="" />
      </div>
    </button>
  </div>`;
const imageTemplateVals = _.template(imageTemplate);
const videoTemplateVals = _.template(videoTemplate);

const removeSelectedState = (itemList) => {
  const selectedBtn = itemList.querySelector('.selected');
  if (selectedBtn) {
    selectedBtn.classList.remove('selected');
  }
};

const updateActiveThumb = (options) => {
  const {
    btn,
    itemList,
  } = options;
  removeSelectedState(itemList);
  btn.classList.add('selected');
};

const updateFullSizeVideo = (options) => {
  const {
    btn,
    fullSizeImg,
  } = options;
  if (fullSizeImg === null) return;
  const thumbImg = btn.querySelector('img');
  const dataVideoUrl = btn.getAttribute('data-video-url');
  // Resize widen image
  const src = getPosterImageFromVideoUrl(thumbImg.src);
  fullSizeImg.innerHTML = videoTemplateVals({
    dataVideoUrl,
    src,
  });
};

const updateFullSizeImage = (options) => {
  const {
    btn,
    fullSizeImg,
  } = options;
  if (fullSizeImg === null) return;
  const thumbImg = btn.querySelector('img');
  // Resize widen image
  const src = updateAssetUrlDimensions({
    height: 400,
    src: thumbImg.src,
    width: 612,
  });
  fullSizeImg.innerHTML = imageTemplateVals({ src });
};

const addGallerySwap = (options) => {
  const {
    btnSelector,
    fullSizeImgSelector,
    groupSelector,
    onUpdate,
  } = options;
  const fullSizeImg = document.querySelector(fullSizeImgSelector);
  const itemList = document.querySelector(groupSelector);
  if (itemList) {
    const btnList = itemList.querySelectorAll(btnSelector);
    [].map.call(btnList, btn => btn.addEventListener('click', () => {
      // Video/image
      const isVideo = btn.classList.contains('product-video-thumb');
      if (isVideo) {
        updateFullSizeVideo({
          btn,
          fullSizeImg,
        });
      } else {
        updateFullSizeImage({
          btn,
          fullSizeImg,
        });
      }
      updateActiveThumb({
        btn,
        itemList,
        onUpdate,
      });
    }));
  }
};

export {
  addGallerySwap,
  updateActiveThumb,
};
/* eslint-enable no-console */
